import React from "react";
import { Link } from "react-router-dom";

export default class Reminders extends React.Component {
  render() {
    return (
      <div>
        <div id="circular-menu" className="circular-menu">
          <a className="floating-btn">
            <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
            <i aria-hidden="true" className="fa fa-times"></i>
          </a>

          <div className="items-wrapper">
            <div className="menu-item is-flex">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-bell"
              >
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
              </svg>
            </div>
            <a
              className="menu-item is-flex right-panel-trigger"
              data-panel="languages-panel"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-bell"
              >
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
              </svg>
            </a>
            <Link to="" className="menu-item is-flex">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-bell"
              >
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
              </svg>
            </Link>
            <a
              className="menu-item is-flex right-panel-trigger"
              data-panel="activity-panel"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-grid"
              >
                <rect x="3" y="3" width="7" height="7"></rect>
                <rect x="14" y="3" width="7" height="7"></rect>
                <rect x="14" y="14" width="7" height="7"></rect>
                <rect x="3" y="14" width="7" height="7"></rect>
              </svg>
            </a>
          </div>
        </div>
        <div className="container-fluid">
          <div className="reminder-screen">
            <div className="row g-3">
              <div className="form-head d-flex flex-wrap align-items-center">
                <div className="me-auto">
                  <h2 className="font-w600 mb-0">All Reminders</h2>
                </div>
                <div className="rightside-tabs">
                  <div className="me-auto das-active">
                    <Link to="ApplyLeave">
                      <h2 className="font-w600 mb-0">All Reminders</h2>
                    </Link>
                  </div>
                  <div className="me-auto">
                    <Link to="">
                      <h2 className="font-w600 mb-0">Active Reminders</h2>
                    </Link>
                  </div>
                  <div className="me-auto">
                    <Link to="">
                      <h2 className="font-w600 mb-0">Expiry Reminders</h2>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-xl-9">
                <div className="row">
                  <div className="col-xl-12">
                    <div
                      className="card"
                      style={
                        {
                          /* background: "#092047; */
                        }
                      }
                    >
                      <div className="card-body display-div">
                        <div className="firstleft-div text-center text-white">
                          <div className="">
                            <img
                              className="avatar is-squared"
                              src="images/org-img/reminders/bg.png"
                            />
                            <h4 className="block-heading">
                              There are no reminders htmlFor today
                            </h4>
                            <p className="block-text">
                              You can create reminders.
                            </p>
                            <button>
                              <Link to="CreateReminders" className="tex-white">
                                Create Reminder
                              </Link>
                            </button>
                          </div>
                        </div>
                        <div className="firstleft-second">
                          <h4 className="block-heading">Reminders Summary</h4>

                          <div className="reminder-list">
                            <div className="re-inner-list">
                              <i className="fa fa-bell-o"></i>
                              <p>Active Reminders</p>
                              <strong>05</strong>
                            </div>
                            <div className="re-inner-list">
                              <i className="fa fa-bell-o"></i>
                              <p>Active Reminders</p>
                              <strong>05</strong>
                            </div>
                            <div className="re-inner-list">
                              <i className="fa fa-bell-o"></i>
                              <p>Active Reminders</p>
                              <strong>05</strong>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-12">
                  <div className="org-leave-card tile-grid tile-grid-v1 row g-3">
                    <span className="fes-span">Normal Reminders</span>

                    {/* <div className="org-edit"> <i className="fa fa-pencil"></i></div> */}

                    <div className="col-xl-4">
                      <div className="card bottom-card">
                        <div className="card-body p-4">
                          <div className="media-body px-0 rem-circle">
                            <div className="">
                              <img
                                className="avatar"
                                src="images/org-img/reminders/icon.png"
                                alt=""
                                data-user-popover="25"
                                data-target="webuiPopover6"
                              />
                              <label className="switch">
                                <input type="checkbox" />
                                <span className="slider round"></span>
                              </label>
                            </div>
                            <h2 className="fss-17 darkh002">
                              <a className="">Reminder Title goes here</a>
                            </h2>
                            <h2 className="mt-0 fss-17 lighth2">
                              <a className="">
                                04:00<span className="span-remi">AM</span>
                              </a>
                            </h2>
                            <span className="mt-0 mb-3 fs-12 datecol">
                              <b>Weekday - </b>Sun Mon
                            </span>
                            <br />
                            <span className="mt-0 mb-3 fs-12 datecol">
                              <b>From -</b> Wed, 19 Oct, 2022
                            </span>
                            <br />
                            <span className="mt-0 mb-3 fs-12 datecol">
                              <b>Expiry -</b> Wed, 19 Oct, 2022
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-xl-4">
                      <div className="card bottom-card">
                        <div className="card-body p-4">
                          <div className="media-body px-0 rem-circle">
                            <div className="">
                              <img
                                className="avatar"
                                src="images/org-img/reminders/icon.png"
                                alt=""
                                data-user-popover="25"
                                data-target="webuiPopover6"
                              />
                              <label className="switch">
                                <input type="checkbox" />
                                <span className="slider round"></span>
                              </label>
                            </div>
                            <h2 className="fss-17 darkh002">
                              <a className="">Reminder Title goes here</a>
                            </h2>
                            <h2 className="mt-0 fss-17 lighth2">
                              <a className="">
                                04:00<span className="span-remi">AM</span>
                              </a>
                            </h2>
                            <span className="mt-0 mb-3 fs-12 datecol">
                              <b>Weekday - </b>Sun Mon
                            </span>
                            <br />
                            <span className="mt-0 mb-3 fs-12 datecol">
                              <b>From -</b> Wed, 19 Oct, 2022
                            </span>
                            <br />
                            <span className="mt-0 mb-3 fs-12 datecol">
                              <b>Expiry -</b> Wed, 19 Oct, 2022
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-xl-4">
                      <div className="card bottom-card">
                        <div className="card-body p-4">
                          <div className="media-body px-0 rem-circle">
                            <div className="">
                              <img
                                className="avatar"
                                src="images/org-img/reminders/icon.png"
                                alt=""
                                data-user-popover="25"
                                data-target="webuiPopover6"
                              />
                              <label className="switch">
                                <input type="checkbox" />
                                <span className="slider round"></span>
                              </label>
                            </div>
                            <h2 className="fss-17 darkh002">
                              <a className="">Reminder Title goes here</a>
                            </h2>
                            <h2 className="mt-0 fss-17 lighth2">
                              <a className="">
                                04:00<span className="span-remi">AM</span>
                              </a>
                            </h2>
                            <span className="mt-0 mb-3 fs-12 datecol">
                              <b>Weekday - </b>Sun Mon
                            </span>
                            <br />
                            <span className="mt-0 mb-3 fs-12 datecol">
                              <b>From -</b> Wed, 19 Oct, 2022
                            </span>
                            <br />
                            <span className="mt-0 mb-3 fs-12 datecol">
                              <b>Expiry -</b> Wed, 19 Oct, 2022
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="org-leave-card tile-grid tile-grid-v1 row g-3">
                    <span className="fes-span">Recurring Reminders</span>
                    <div className="col-xl-4">
                      <div className="card bottom-card">
                        <div className="card-body p-4">
                          <div className="media-body px-0 rem-circle">
                            <div className="">
                              <img
                                className="avatar"
                                src="images/org-img/reminders/icon.png"
                                alt=""
                                data-user-popover="25"
                                data-target="webuiPopover6"
                              />
                              <label className="switch">
                                <input type="checkbox" />
                                <span className="slider round"></span>
                              </label>
                            </div>
                            <h2 className="fss-17 darkh002">
                              <a className="">Reminder Title goes here</a>
                            </h2>
                            <h2 className="mt-0 fss-17 lighth2">
                              <a className="">
                                04:00<span className="span-remi">AM</span>
                              </a>
                            </h2>
                            <span className="mt-0 mb-3 fs-12 datecol">
                              <b>Weekday - </b>Sun Mon
                            </span>
                            <br />
                            <span className="mt-0 mb-3 fs-12 datecol">
                              <b>From -</b> Wed, 19 Oct, 2022
                            </span>
                            <br />
                            <span className="mt-0 mb-3 fs-12 datecol">
                              <b>Expiry -</b> Wed, 19 Oct, 2022
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-xl-4">
                      <div className="card bottom-card">
                        <div className="card-body p-4">
                          <div className="media-body px-0 rem-circle">
                            <div className="">
                              <img
                                className="avatar"
                                src="images/org-img/reminders/icon.png"
                                alt=""
                                data-user-popover="25"
                                data-target="webuiPopover6"
                              />
                              <label className="switch">
                                <input type="checkbox" />
                                <span className="slider round"></span>
                              </label>
                            </div>
                            <h2 className="fss-17 darkh002">
                              <a className="">Reminder Title goes here</a>
                            </h2>
                            <h2 className="mt-0 fss-17 lighth2">
                              <a className="">
                                04:00<span className="span-remi">AM</span>
                              </a>
                            </h2>
                            <span className="mt-0 mb-3 fs-12 datecol">
                              <b>Weekday - </b>Sun Mon
                            </span>
                            <br />
                            <span className="mt-0 mb-3 fs-12 datecol">
                              <b>From -</b> Wed, 19 Oct, 2022
                            </span>
                            <br />
                            <span className="mt-0 mb-3 fs-12 datecol">
                              <b>Expiry -</b> Wed, 19 Oct, 2022
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-xl-4">
                      <div className="card bottom-card">
                        <div className="card-body p-4">
                          <div className="media-body px-0 rem-circle">
                            <div className="">
                              <img
                                className="avatar"
                                src="images/org-img/reminders/icon.png"
                                alt=""
                                data-user-popover="25"
                                data-target="webuiPopover6"
                              />
                              <label className="switch">
                                <input type="checkbox" />
                                <span className="slider round"></span>
                              </label>
                            </div>
                            <h2 className="fss-17 darkh002">
                              <a className="">Reminder Title goes here</a>
                            </h2>
                            <h2 className="mt-0 fss-17 lighth2">
                              <a className="">
                                04:00<span className="span-remi">AM</span>
                              </a>
                            </h2>
                            <span className="mt-0 mb-3 fs-12 datecol">
                              <b>Weekday - </b>Sun Mon
                            </span>
                            <br />
                            <span className="mt-0 mb-3 fs-12 datecol">
                              <b>From -</b> Wed, 19 Oct, 2022
                            </span>
                            <br />
                            <span className="mt-0 mb-3 fs-12 datecol">
                              <b>Expiry -</b> Wed, 19 Oct, 2022
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-3">
                <div className="card bg-white">
                  <div className="reminder-sidediv p-4 pb-0">
                    <img src="images/org-img/reminders/img.png" />
                    <div></div>
                  </div>

                  <div className="col-xl-12 p-3 mt-4">
                    <div className="upcomingdiv">
                      <div className="d-flex">
                        <h4 className="sideh432 mb-4">Action Pending</h4>
                      </div>

                      <div className="media mb-2 event-list">
                        <div className="text-center date-bx data1">
                          <img
                            src="images/org-img/reminders/yes-no.png"
                            className="w-100"
                          />
                        </div>
                        <div className="media-body px-0 data2">
                          <h6 className="mt-0 mb-0 fss-14">
                            <a className="text-black">Meeting with Client</a>
                          </h6>
                          <span className="mt-0 mb-3 datecol">
                            <b className="text-dark">by</b> Divya,{" "}
                            <b className="text-dark">at</b> 20-2-22
                          </span>
                        </div>
                        <div className="data3">
                          <img
                            src="images/org-img/reminders/check1.png"
                            data-toggle="tooltip"
                            data-placement="right"
                            title="Accept"
                          />
                          <img
                            src="images/org-img/reminders/close.png"
                            data-toggle="tooltip"
                            data-placement="right"
                            title="Reject"
                          />
                        </div>
                      </div>
                      <div className="media mb-2 event-list">
                        <div className="text-center date-bx data1">
                          <img
                            src="images/org-img/reminders/yes-no.png"
                            className="w-100"
                          />
                        </div>
                        <div className="media-body px-0 data2">
                          <h6 className="mt-0 mb-0 fss-14">
                            <a className="text-black">Meeting with Client</a>
                          </h6>
                          <span className="mt-0 mb-3 datecol">
                            <b className="text-dark">by</b> Divya,{" "}
                            <b className="text-dark">at</b> 20-2-22
                          </span>
                        </div>
                        <div className="data3">
                          <img
                            src="images/org-img/reminders/check1.png"
                            data-toggle="tooltip"
                            data-placement="right"
                            title="Accept"
                          />
                          <img
                            src="images/org-img/reminders/close.png"
                            data-toggle="tooltip"
                            data-placement="right"
                            title="Reject"
                          />
                        </div>
                      </div>
                      <div className="media mb-2 event-list">
                        <div className="text-center date-bx data1">
                          <img
                            src="images/org-img/reminders/yes-no.png"
                            className="w-100"
                          />
                        </div>
                        <div className="media-body px-0 data2">
                          <h6 className="mt-0 mb-0 fss-14">
                            <a className="text-black">Meeting with Client</a>
                          </h6>
                          <span className="mt-0 mb-3 datecol">
                            <b className="text-dark">by</b> Divya,{" "}
                            <b className="text-dark">at</b> 20-2-22
                          </span>
                        </div>
                        <div className="data3">
                          <img
                            src="images/org-img/reminders/check1.png"
                            data-toggle="tooltip"
                            data-placement="right"
                            title="Accept"
                          />
                          <img
                            src="images/org-img/reminders/close.png"
                            data-toggle="tooltip"
                            data-placement="right"
                            title="Reject"
                          />
                        </div>
                      </div>
                      <div className="media mb-2 event-list">
                        <div className="text-center date-bx data1">
                          <img
                            src="images/org-img/reminders/yes-no.png"
                            className="w-100"
                          />
                        </div>
                        <div className="media-body px-0 data2">
                          <h6 className="mt-0 mb-0 fss-14">
                            <a className="text-black">Meeting with Client</a>
                          </h6>
                          <span className="mt-0 mb-3 datecol">
                            <b className="text-dark">by</b> Divya,{" "}
                            <b className="text-dark">at</b> 20-2-22
                          </span>
                        </div>
                        <div className="data3">
                          <img
                            src="images/org-img/reminders/check1.png"
                            data-toggle="tooltip"
                            data-placement="right"
                            title="Accept"
                          />
                          <img
                            src="images/org-img/reminders/close.png"
                            data-toggle="tooltip"
                            data-placement="right"
                            title="Reject"
                          />
                        </div>
                      </div>

                      <div className="card-body pb-0"></div>
                    </div>
                  </div>
                </div>

                <div className="card bg-white">
                  <div className="col-xl-12 p-3">
                    <div className="upcomingdiv">
                      <div className="d-flex">
                        <h4 className="text-primary sideh432 mb-4">Upcoming</h4>
                      </div>

                      <div className="media mb-2 event-list">
                        <div className="text-center date-bx data1">
                          <img
                            src="images/org-img/reminders/icon0.png"
                            className="w-100"
                          />
                        </div>
                        <div className="media-body px-0 data2">
                          <h6 className="mt-0 mb-0 fss-14">
                            <a className="text-black">Meeting with Client</a>
                          </h6>
                          <span className="mt-0 mb-3 datecol">
                            <b className="text-dark">by</b> Divya,{" "}
                            <b className="text-dark">at</b> 20-2-22
                          </span>
                        </div>
                        <div className="rem-circle02">
                          <label className="switch">
                            <input type="checkbox" />
                            <span className="slider round"></span>
                          </label>
                        </div>
                      </div>
                      <div className="media mb-2 event-list">
                        <div className="text-center date-bx data1">
                          <img
                            src="images/org-img/reminders/icon0.png"
                            className="w-100"
                          />
                        </div>
                        <div className="media-body px-0 data2">
                          <h6 className="mt-0 mb-0 fss-14">
                            <a className="text-black">Meeting with Client</a>
                          </h6>
                          <span className="mt-0 mb-3 datecol">
                            <b className="text-dark">by</b> Divya,{" "}
                            <b className="text-dark">at</b> 20-2-22
                          </span>
                        </div>
                        <div className="rem-circle02">
                          <label className="switch">
                            <input type="checkbox" />
                            <span className="slider round"></span>
                          </label>
                        </div>
                      </div>
                      <div className="media mb-2 event-list">
                        <div className="text-center date-bx data1">
                          <img
                            src="images/org-img/reminders/icon0.png"
                            className="w-100"
                          />
                        </div>
                        <div className="media-body px-0 data2">
                          <h6 className="mt-0 mb-0 fss-14">
                            <a className="text-black">Meeting with Client</a>
                          </h6>
                          <span className="mt-0 mb-3 datecol">
                            <b className="text-dark">by</b> Divya,{" "}
                            <b className="text-dark">at</b> 20-2-22
                          </span>
                        </div>
                        <div className="rem-circle02">
                          <label className="switch">
                            <input type="checkbox" />
                            <span className="slider round"></span>
                          </label>
                        </div>
                      </div>
                      <div className="media mb-2 event-list">
                        <div className="text-center date-bx data1">
                          <img
                            src="images/org-img/reminders/icon0.png"
                            className="w-100"
                          />
                        </div>
                        <div className="media-body px-0 data2">
                          <h6 className="mt-0 mb-0 fss-14">
                            <a className="text-black">Meeting with Client</a>
                          </h6>
                          <span className="mt-0 mb-3 datecol">
                            <b className="text-dark">by</b> Divya,{" "}
                            <b className="text-dark">at</b> 20-2-22
                          </span>
                        </div>
                        <div className="rem-circle02">
                          <label className="switch">
                            <input type="checkbox" />
                            <span className="slider round"></span>
                          </label>
                        </div>
                      </div>

                      <div className="card-body pb-0"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <!--**********************************
                                                            Content body end
        ***********************************--> */}

          <div className="modal fade" id="contact-manager">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title m-auto">
                    Contact Your Reporting Manager htmlFor Any Leave
                    Clarifications
                  </h5>
                </div>
                <div className="modal-body text-center">
                  <form>
                    <div className="form-group text-left">
                      <label>Repoting Manager</label>
                      <select className="default-select form-control wide mb-3">
                        <option selected disabled>
                          Select reporting manager
                        </option>
                        <option>Arun Mishra</option>
                        <option>Pragya Tiwari</option>
                        <option>Alisha Goyal</option>
                      </select>
                    </div>
                    <div className="form-group text-left">
                      <label className="mt-3">Reason</label>
                      <textarea
                        rows="4"
                        cols="1"
                        className="form-control"
                      ></textarea>
                    </div>
                  </form>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-danger light"
                    data-bs-dismiss="modal"
                  >
                    Decline
                  </button>
                  <button type="button" className="btn btn-primary">
                    Accept
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
